"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ExtendableError_1 = __importDefault(require("../ExtendableError"));
/**
 * Thrown when attempting operations on some relation (table, view...) that does
 * not exist
 * @param {string} relation
 */
class RelationDoesNotExistError extends ExtendableError_1.default {
    constructor(relationName) {
        super(`relation ${relationName} does not exist`);
        this.relationName = relationName;
        this.relationName = relationName;
    }
}
exports.default = RelationDoesNotExistError;
